import { useContext } from 'react';

import { moduleContext } from '../../showcase-include';

import { ModuleContext } from './context';

/**
 * @description Get custom context
 * @return context
 */
export function useCustomContext(): any {
  const name = useContext(ModuleContext);
  const ctx = moduleContext(`module_${name}`);
  if (ctx) {
    return ctx.custom;
  }
}
